<template>
  <div class="ccui-app-container">
    <div class="ccui-advanced-search-wrapper ccui-clearfix">
      <!-- <div class="ccui-search-wrapper"> -->
      <el-search
        :formProp="formData"
        @search="searchItem"
        :isShowSearch="isShowSearch"
        class="ccui-highsearch"
        :selectClear="true"
        :isShow="isShow"
      >
        <div class="ccui-tab-wrapper">
          <el-button
            :type="isFocus === 1 ? 'table-top-active' : 'table-top'"
            size="mini"
            >全部 ({{ totalNum }})</el-button
          >
        </div>
        <div class="ccui-extend-btn">
          <el-button
            size="mini"
            type="primary"
            ref="listquery-new-item"
            @click="jumpNew"
            icon="icon-ccui-add-sup"
            >新增人员</el-button
          >
        </div>
        <template slot="search">
          <el-input
            v-model="formData.userName"
            clearable
            searchLabel="姓名"
            placeholder="请输入姓名模糊查询"
          ></el-input>
          <el-select
            v-model="formData.sex"
            clearable
            placeholder="请选择性别查询"
            searchLabel="性别"
          >
            <el-option key="1" label="男" value="1"></el-option>
            <el-option key="2" label="女" value="2"></el-option>
          </el-select>
          <el-date-picker
            v-model="formData.birthday"
            type="date"
            searchLabel="出生日期"
            value-format="yyyy-MM-dd"
            placeholder="请输入出生日期查询"
          ></el-date-picker>
          <el-select
            v-model="formData.politicalOutlook"
            clearable
            placeholder="请选择政治面貌查询"
            searchLabel="政治面貌"
          >
            <el-option
              v-for="item in politicalOutlookOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="formData.isMarried"
            clearable
            placeholder="请选择婚姻状况查询"
            searchLabel="婚姻状况"
          >
            <el-option key="0" label="未婚" value="0"></el-option>
            <el-option key="1" label="已婚" value="1"></el-option>
          </el-select>
        </template>
        <!-- 表单高级搜索 -->
        <el-input
          v-model="formData.userName"
          clearable
          searchLabel="姓名"
          placeholder="请输入姓名模糊查询"
          slot="searchItem1"
          style="width:160px"
        ></el-input>
        <el-select
          v-model="formData.sex"
          clearable
          placeholder="请选择性别查询"
          searchLabel="性别"
          slot="searchItem2"
          style="width:160px"
        >
          <el-option key="1" label="男" value="1"></el-option>
          <el-option key="2" label="女" value="2"></el-option>
        </el-select>
        <el-date-picker
          v-model="formData.birthday"
          type="date"
          searchLabel="出生日期"
          value-format="yyyy-MM-dd"
          placeholder="请输入出生日期查询"
          slot="searchItem3"
          style="width:160px"
        ></el-date-picker>
        <el-select
          v-model="formData.politicalOutlook"
          clearable
          placeholder="请选择政治面貌查询"
          searchLabel="政治面貌"
          slot="searchItem4"
          style="width:160px"
        >
          <el-option
            v-for="item in politicalOutlookOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          v-model="formData.isMarried"
          clearable
          placeholder="请选择婚姻状况查询"
          searchLabel="婚姻状况"
          slot="searchItem5"
          style="width:160px"
        >
          <el-option key="0" label="未婚" value="0"></el-option>
          <el-option key="1" label="已婚" value="1"></el-option>
        </el-select>
      </el-search>
    </div>
    <!-- 表格 -->
    <div class="ccui-multifunctional-table-wrapper">
      <el-table
        ref="multipleTable"
        :data="tableData"
        :fit="true"
        :row-style="setRowclass"
        :cell-style="setStyle"
        border
        class="ccui-multifunctional-table"
        @select-all="handleCheckAllChange"
        @select="handleCheckChange"
        @selection-change="handleSelectionChange"
        @header-dragend="setTableTitleWidth"
        @sort-change="changeSort"
        max-height="20000"
        v-if="draggFlag"
      >
        <el-table-column type="selection" width="28"></el-table-column>
        <template v-for="(table, index) in tableTheadOptions">
          <el-table-column
            v-if="table.checked"
            :fixed="table.fixed || false"
            :key="index"
            :type="table.type"
            :label="table.label"
            :align="table.align || 'left'"
            :header-align="table.headerAlign || 'left'"
            :min-width="table.width"
            :prop="table.prop"
            :formatter="formatterList[table.formatterName]"
            :show-overflow-tooltip="true"
            border="true"
          >
          </el-table-column>
        </template>

        <el-table-column label="操作" width="127" fixed="right">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              ref="listquery-item-detail"
              v-if="isShowDetail"
              @click="jumpDetail(scope.$index, scope.row)"
              >查看</el-button
            >
            <el-button
              v-if="isShowEdit"
              size="mini"
              type="text"
              ref="listquery-edit-item"
              @click="jumpEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button
              v-if="true"
              size="mini"
              type="text"
              @click="handleDelete(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
          <template v-slot:header>
            <div class="ccui-multifunctional-table-wrapper-operation">
              <span>操作</span>
              <el-popover
                placement="right"
                popper-class="ccui-multifunctional-table-wrapper_setting__popover"
                trigger="click"
              >
                <el-checkbox
                  v-for="(e, i) in fixedTableThead"
                  :key="i"
                  :checked="e.checked"
                  disabled
                  class="ccui-popover-disabled"
                  >{{ e.label }}</el-checkbox
                >
                <div class="ccui-popover-line"></div>
                <draggable
                  :list="unfixedTableThead"
                  class="ccui-draggable"
                  @change="handleTableChange"
                >
                  <el-checkbox-group
                    v-for="(item, index) in unfixedTableThead"
                    v-model="item.checked"
                    :key="index"
                  >
                    <el-checkbox
                      :label="item"
                      :checked="item.checked"
                      :width="item.width"
                      :title="item.label"
                      @change="handleUpdate(item, index)"
                      >{{ item.label }}</el-checkbox
                    >
                  </el-checkbox-group>
                </draggable>
                <!-- <i
                  class="el-icon-s-tools ccui-multifunctional-table-wrapper_setting__icon"
                  slot="reference"
                ></i>-->
              </el-popover>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="ccui-table-footer" v-show="isShowPagination">
        <div class="ccui-operation">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChangeBottom"
            >全选</el-checkbox
          >
          <!--          <div class="ccui-table-btn">-->
          <el-button
            v-show="isSelection"
            size="mini"
            type="default"
            @click="handleDelSelected"
            class="ccui-table-btn"
            >批量删除</el-button
          >
          <!--          <el-button size="mini" type="default" icon="icon-ccui-export" class="ccui-table-btn">导出</el-button>-->
          <el-export-button
            placement="bottom"
            @export-excel="handleExport"
            @export-pdf="handleExport('all')"
            class="ccui-table-btn"
          ></el-export-button>
        </div>
        <div id="ccui-paging">
          <el-pagination
            :total="totalNum"
            :page-size="getLocalPageSize()"
            :current-page="pageNoCode"
            :page-sizes="[10, 20, 50, 100, 200, 500]"
            background
            layout="total, sizes, prev, pager, next, jumper"
            popper-class="ccui-paging-page-size-popper"
            @prev-click="handlePrev"
            @next-click="handleNext"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
          <el-button
            class="ccui-pagination-btn"
            size="mini"
            type="default"
            @click="handleSizeChange('none')"
            >确定</el-button
          >
        </div>
      </div>
    </div>
    <!-- 表格 end -->
  </div>
</template>

<script>
require("core-js/modules/es.object.assign");
require("core-js/modules/es.object.keys");
require("regenerator-runtime/runtime");
require("core-js/modules/es.object.values");
require("core-js/modules/es.object.set-prototype-of");
require("core-js/modules/es.array.find");
require("core-js/modules/es.array-buffer.is-view");
require("core-js/modules/es.weak-map");
require("core-js/modules/es.promise");
const ExcelJS = require("exceljs");
import { saveAs } from "file-saver";
import draggable from "vuedraggable";
import { removeDemoUser, getListbycheck } from "../api/item-list";
import {
  setSessionItem,
  getSessionItem,
  removeSessionItem,
  ishasAgentId
} from "@/basa/utils";
export default {
  components: {
    draggable
  },
  name: "listquery-item-list",
  data() {
    return {
      isShowDetail: true,
      isShowEdit: true,
      multiDataToEnd: {},
      singleDataToEnd: {},
      // 表格相关
      tableData: [], // 表格数据
      draggFlag: true,
      tableName: this.tableList.listqueryList, // 表格命名
      tableThead: [], // 表格数据
      // 锁定表格
      fixedTableThead: [
        {
          label: "序号",
          prop: "id",
          width: "38",
          checked: true,
          fixed: true,
          type: "index",
          resizable: false
        }
      ],
      // 非锁定表格
      unfixedTableThead: [
        {
          label: "姓名",
          prop: "userName",
          width: "62",
          checked: true
        },
        {
          label: "性别",
          prop: "sex",
          width: "60",
          checked: true,
          formatterName: "sexHandler"
        },
        {
          label: "出生日期",
          prop: "birthday",
          width: "120",
          checked: true
        },
        {
          label: "政治面貌",
          prop: "politicalOutlook",
          width: "80",
          checked: true,
          formatterName: "outlookHandler"
        },
        {
          label: "工龄",
          prop: "workYears",
          width: "60",
          checked: true
        },
        {
          label: "婚姻状况",
          prop: "isMarried",
          width: "72",
          checked: true,
          formatterName: "ismarriedHandler"
        },
        {
          label: "年收入",
          prop: "annualIncome",
          width: "80",
          checked: true,
          align: "right",
          headerAlign: "left"
        },
        {
          label: "身份证号",
          prop: "idNum",
          width: "142",
          checked: true,
          formatterName: "idNumHandle"
        },
        {
          label: "手机号",
          prop: "userMobile",
          width: "120",
          checked: true,
          formatterName: "userMobileHandle"
        },
        {
          label: "备注",
          prop: "remarks",
          width: "300",
          checked: true
        }
      ],
      // 动态表格
      tableTheadOptions: [],
      // 弹框表格
      // popoverShow: false,
      selectRow: [],
      selectData: [],
      isFocus: 1,

      // 表格相关 end
      // 高级搜索数据 start
      formData: {
        userName: "",
        sex: "",
        birthday: "",
        politicalOutlook: "",
        isMarried: ""
      }, // 高级搜索提交数据
      formDataSearch: "",
      localSearchData: {},
      politicalOutlookOptions: [
        {
          label: "群众",
          value: "1"
        },
        {
          label: "团员",
          value: "2"
        },
        {
          label: "党员",
          value: "3"
        }
      ],
      isShowSearch: true,
      isShow: false,
      // 高级搜索数据 end
      isShowPagination: false, //无数据的不展示底部全选，批量删除
      // 全选以及页码
      totalNum: 0,
      total: 0,
      isIndeterminate: false,
      checkAll: false,
      value: "",
      pageNoCode: this.getLocalPageNo(),
      pageSizeCode: this.getLocalPageSize(),
      // isFist: false,
      // 全选以及页码 end
      // 表格数据删除相关
      delDemoId: "",
      content: "您确定要删除吗？",
      typeDel: "", //有关批量删除
      isSelection: false,
      // 表格数据删除相关 end
      // 排序入参所需字段
      sortord: "",
      sortprop: "",
      // 表格数据相关处理
      formatterList: {
        sexHandler(row, col) {
          switch (row.sex) {
            case 1:
              return "男";
            case 2:
              return "女";
          }
        },
        outlookHandler(row, col) {
          switch (row.politicalOutlook) {
            case 1:
              return "群众";
            case 2:
              return "团员";
            case 3:
              return "党员";
          }
        },
        ismarriedHandler(row, col) {
          switch (row.isMarried) {
            case 0:
              return "未婚";
            case 1:
              return "已婚";
          }
        },
        userMobileHandle(row) {
          var reg = /(\d{3})\d{4}(\d{4})/;
          return row.userMobile
            ? (row.userMobile = row.userMobile.replace(reg, "$1****$2"))
            : (row.userMobile = "");
        },
        idNumHandle(row) {
          var reg = /(\d{6})(\d+)(\d{3}[0-9xX])/;
          return row.idNum
            ? (row.idNum = row.idNum.replace(reg, "$1********$3"))
            : (row.idNum = "");
        },
        isCreated: false
      }
      // 表格数据相关处理 end
    };
  },
  mounted() {
    this.setInitData();
  },
  watch: {
    selectData(data) {
      this.selectRow = [];
      if (data.length > 0) {
        data.forEach((item, index) => {
          this.selectRow.push(this.tableData.indexOf(item));
        });
      }
    }
  },
  methods: {
    setInitData() {
      this.isShow = false;
      // this.getUserList();
      this.setTableWidth();
      this.renderTable();
      // this.isFist = false;
    },
    // 导出
    async handleExport(type) {
      let sexObj = {
        1: "男",
        2: "女"
      };
      let politicalOutlookobj = {
        1: "群众",
        2: "团员",
        3: "党员"
      };
      let isMarriedobj = {
        0: "未婚",
        1: "已婚"
      };
      const wb = new ExcelJS.Workbook();
      const ws1 = wb.addWorksheet("第一页");
      const page1Row1 = ws1.addRow([
        "序号",
        "姓名",
        "性别",
        "出生日期",
        "政治面貌",
        "工龄",
        "婚姻状况",
        "年收入",
        "身份证号",
        "手机号",
        "备注"
      ]);
      if (type === "all") {
        let res = await getListbycheck({
          pageNo: 1,
          userName: "",
          pageSize: 5000,
          sortprop: "",
          sortord: "",
          isDelete: 0
        });
        if (res.data.data.rows.length > 0) {
          res.data.data.rows.forEach((item, index) => {
            ws1.addRow([
              index + 1,
              item.userName,
              sexObj[item.sex],
              item.birthday ? item.birthday.substr(0, 10) : "",
              politicalOutlookobj[item.politicalOutlook],
              item.workYears,
              isMarriedobj[item.isMarried],
              type === "all"
                ? item.annualIncome
                  ? "￥" + item.annualIncome.toFixed(2)
                  : ""
                : item.annualIncome,
              item.idNum
                ? item.idNum.replace(
                    /(\d{6})(\d+)(\d{3}[0-9xX])/,
                    "$1********$3"
                  )
                : "",
              item.userMobile
                ? item.userMobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
                : "",
              item.remarks
            ]);
          });
        }
      } else {
        this.tableData.forEach((item, index) => {
          ws1.addRow([
            index + 1,
            item.userName,
            sexObj[item.sex],
            item.birthday ? item.birthday.substr(0, 10) : "",
            politicalOutlookobj[item.politicalOutlook],
            item.workYears,
            isMarriedobj[item.isMarried],
            type === "all"
              ? item.annualIncome
                ? "￥" + item.annualIncome.toFixed(2)
                : ""
              : item.annualIncome,
            item.idNum
              ? item.idNum.replace(/(\d{6})(\d+)(\d{3}[0-9xX])/, "$1********$3")
              : "",
            item.userMobile
              ? item.userMobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
              : "",
            item.remarks
          ]);
        });
      }
      ws1.columns = [
        { key: "id", width: 5 },
        { key: "userName", width: 10 },
        { key: "sex", width: 8 },
        { key: "birthday", width: 20 },
        { key: "politicalOutlook", width: 10 },
        { key: "workYears", width: 10 },
        { key: "isMarried", width: 10 },
        { key: "annualIncome", width: 15 },
        { key: "idNum", width: 20 },
        { key: "userMobile", width: 20 },
        { key: "remarks", width: 70 }
      ];
      page1Row1.font = { bold: true, color: { argb: "00489A" } };
      page1Row1.fill = { color: { argb: "000000" } };
      const buf = await wb.xlsx.writeBuffer();
      saveAs(new Blob([buf]), "增删改查.xlsx");
    },
    // 根据返回状态显示不同的文字颜色
    // eslint-disable-next-line no-unused-vars
    setStyle({ row, column, rowIndex, columnIndex }) {
      if (this.selectRow.includes(rowIndex)) {
        return { "background-color": "transparent" };
      }
    },
    // 默认渲染表格
    renderTable() {
      const localTableData = localStorage.getItem(this.tableName)
        ? JSON.parse(localStorage.getItem(this.tableName))
        : [];
      let unfixedTableThead = this.unfixedTableThead.concat(
        this.fixedTableThead
      );
      let localTableDataStr = localTableData.map(
        ({ label, prop, formatter, align }) =>
          JSON.stringify({ label, prop, formatter, align })
      );
      let unfixedTableTheadStr = unfixedTableThead.map(
        ({ label, prop, formatter, align }) =>
          JSON.stringify({ label, prop, formatter, align })
      );

      if (localTableData.length === unfixedTableThead.length) {
        let flag = localTableDataStr.every(item =>
          unfixedTableTheadStr.includes(item)
        );
        if (flag) {
          // 完全相同
          this.tableTheadOptions = localTableData;
          this.tableThead = localTableData;
          this.unfixedTableThead = localTableData.filter(item => {
            return !this.fixedTableThead.find(
              cItem => item.prop === cItem.prop
            );
          });
        } else {
          // 长度相同但值不同
          this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
          const comment = JSON.stringify(this.tableThead);
          localStorage.setItem(this.tableName, comment);
          const localTableData = JSON.parse(
            localStorage.getItem(this.tableName)
          );
          this.tableTheadOptions = localTableData;
        }
      } else {
        // 长度不同
        this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
        const comment = JSON.stringify(this.tableThead);
        localStorage.setItem(this.tableName, comment);
        const localTableData = JSON.parse(localStorage.getItem(this.tableName));
        this.tableTheadOptions = localTableData;
      }
    },
    // 表格弹框拖拽触发
    handleTableChange(val) {
      this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
      const comment = JSON.stringify(this.tableThead);
      localStorage.setItem(this.tableName, comment);
      const localTableData = JSON.parse(localStorage.getItem(this.tableName));
      this.tableTheadOptions = localTableData;
    },
    // 是否显示对应列
    handleUpdate(item, index) {
      for (let i = 0; i < this.unfixedTableThead.length; i++) {
        if (i === index) {
          this.unfixedTableThead.checked = !this.unfixedTableThead.checked;
        }
      }
      this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
      const comment = JSON.stringify(this.tableThead);
      localStorage.setItem(this.tableName, comment);
      const localTableData = JSON.parse(localStorage.getItem(this.tableName));
      this.tableTheadOptions = localTableData;
    },
    // 渲染本地存储表格宽度
    setTableWidth() {
      const localTableData = JSON.parse(localStorage.getItem(this.tableName));
      if (localTableData) {
        for (let i = 0; i < this.tableTheadOptions.length; i++) {
          if (this.tableTheadOptions[i].label === localTableData[i].label) {
            this.tableTheadOptions[i].width = localTableData[i].width;
          }
        }
      }
    },
    // 表格宽度更改存入
    setTableTitleWidth(newWidth, oldWidth, column, event) {
      for (let i = 0; i < this.unfixedTableThead.length; i++) {
        if (this.unfixedTableThead[i].label === column.label) {
          this.unfixedTableThead[i].width = newWidth;
        }
      }
      this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
      const comment = JSON.stringify(this.tableThead);
      localStorage.setItem(this.tableName, comment);
      this.tableTheadOptions = JSON.parse(localStorage.getItem(this.tableName));
      this.draggFlag = false;
      this.$nextTick(() => {
        this.draggFlag = true;
      });
    },
    handleSelectionChange(data) {
      this.selectData = data;
    },
    setRowclass({ row, rowIndex }) {
      if (this.selectRow.includes(rowIndex)) {
        return { "background-color": "rgba(255,232,195,1) " };
      }
    },
    // 跳转编辑页
    jumpEdit(index, row) {
      this.$router.push("/list-query/singleTab/edit-item/" + row.id);
    },
    // 跳转详情页
    jumpDetail(index, row) {
      this.$router.push(`/list-query/singleTab/item-detail/${row.id}/${index}`);
    },
    // 跳转新增页
    jumpNew() {
      this.$router.push("/list-query/singleTab/new-item");
    },
    // 删除列表数据
    handleDelete(index, row) {
      this.deleteLog();
      this.delDemoId = row.id;
    },
    // 删除弹框
    deleteLog() {
      this.$confirm("您确定要删除吗？", "删除确认", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        customClass: "ccui-message-box-custom"
      })
        .then(() => {
          if (this.typeDel == "all") {
            this.delPeople(this.idArrSelected);
          } else {
            this.delPeople([this.delDemoId]);
          }
        })
        .catch(() => {
          console.log("取消删除");
        });
    },
    // 批量删除并刷新列表
    handleDelSelected() {
      if (this.idArrSelected) {
        this.typeDel = "all";
        this.deleteLog();
      } else {
        this.$message({
          message: "请选择您要删除的数据",
          type: "warning"
        });
      }
    },
    // 上一页
    handlePrev() {
      console.log("上一页");
    },
    // 下一页
    handleNext() {
      console.log("下一页");
    },
    // 每页条数发生改变
    handleSizeChange(val) {
      this.pageNoCode = 1;
      if (val !== "none") {
        this.pageSizeCode = val;
        setSessionItem("pageSize", this.tableName, val);
      }
      this.getUserList(this.formDataSearch);
    },
    // 当前页发生改变
    handleCurrentChange(val) {
      let searchFormData = getSessionItem("pageNo", this.tableName) || {};
      setSessionItem("pageNo", this.tableName, {
        pageNo: val,
        searchForm: searchFormData.searchForm || {}
      });
      this.formDataSearch = {
        ...this.formDataSearch,
        ...searchFormData.searchForm
      };
      // 跳转翻页都会调这个方法
      this.pageNoCode = val;
      this.getUserList(this.formDataSearch);
    },
    // 高级搜索所需函数 start
    // 高级搜索展开按钮
    searchItem(searchData) {
      this.pageNoCode = 1;
      this.formDataSearch = searchData;
      this.localSearchData = JSON.parse(JSON.stringify(searchData));
      setSessionItem("pageNo", this.tableName, {
        pageNo: this.pageNoCode,
        searchForm: this.localSearchData
      });
      console.log(this.formDataSearch.birthday);
      this.getUserList(this.formDataSearch);
    },
    // 高级搜索 end
    // 列表数据请求
    getUserList(reqObj) {
      console.log(this.pageNoCode);
      let obj = {};
      obj = typeof reqObj == "object" ? reqObj : obj;
      obj.pageNo = this.pageNoCode;
      obj.business = "";
      obj.pageSize = this.pageSizeCode;
      obj.isDelete = 0;
      obj.isShowPageLoading = true;
      getListbycheck(obj)
        .then(res => {
          console.log(res);
          this.isShowPagination = res.data.data.recordsTotal > 0;
          this.tableData = res.data.data.rows;
          this.totalNum = res.data.data.recordsTotal;
          this.total = res.data.data.total;
          this.pageNoCode = res.data.data.pageNo; // 当前页
          this.tableData.forEach((i, index) => {
            i.annualIncome = i.annualIncome
              ? "￥" + i.annualIncome.toFixed(2)
              : "";
            i.birthday = i.birthday ? i.birthday.substr(0, 10) : "";
            this.handleCheckChange(i);
          });
        })
        .catch(e => {
          // console.log(e);
        });
    },
    // 删除数据请求
    delPeople(arr) {
      removeDemoUser({
        ids: arr,
        isShowLoading: true,
        loadingMessage: "删除中,请稍等..."
      }).then(res => {
        this.$message({
          message: "删除成功",
          type: "success",
          // duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        this.$refs.multipleTable.tableData.length <= 1 && --this.pageNoCode;
        this.getUserList();
        this.isSelection = false;
        this.isIndeterminate = false;
      });
    },
    // 全选
    handleCheckAllChange(val) {
      this.isIndeterminate = false;
      const arr = [];
      for (let i = 0; i < val.length; i++) {
        arr.push(val[i].id);
      }
      this.idArrSelected = arr;
      if (val.length) {
        this.isSelection = true;
      } else {
        this.isSelection = false;
      }
      if (typeof val === "boolean") {
        if (val) {
          this.toggleSelection(this.tableData);
        } else {
          this.toggleSelection([]);
        }
      } else {
        this.checkAll = val.length !== 0;
      }
    },
    // 底部全选
    handleCheckAllChangeBottom() {
      this.$refs.multipleTable.toggleAllSelection();
    },
    // 单个数据选中
    handleCheckChange(val) {
      const arr = [];
      for (let i = 0; i < val.length; i++) {
        arr.push(val[i].id);
      }
      this.idArrSelected = arr;
      if (val.length) {
        this.isSelection = true;
      } else {
        this.isSelection = false;
      }
      if (val.length > 0 && val.length < this.tableData.length) {
        this.isIndeterminate = true;
      } else if (val.length === this.tableData.length) {
        this.checkAll = true;
        this.isIndeterminate = false;
      } else {
        this.checkAll = false;
        this.isIndeterminate = false;
      }
    },
    toggleSelection(rows) {
      this.$refs.multipleTable.clearSelection();
      const arr = [];
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
          arr.push(row.id);
        });
        this.idArrSelected = arr;
      }
    },
    // 排序
    changeSort(params) {
      this.sortord = params.order;
      this.sortprop = params.prop;
      this.getUserList();
    },
    // 默认显示多少条
    getLocalPageSize() {
      return getSessionItem("pageSize", this.tableList.listqueryList) || 20;
    },
    // 读取当前页缓存
    getLocalPageNo() {
      let localData = getSessionItem("pageNo", this.tableList.listqueryList);
      return (localData && localData.pageNo) || 1;
    }
  },
  beforeRouteLeave(to, from, next) {
    removeSessionItem("pageNo");
    for (var key in this.$vnode.parent.parent.componentInstance.cache) {
      delete this.$vnode.parent.parent.componentInstance.cache[
        ishasAgentId(to.path, key)
      ];
    }
    next();
  },
  activated() {
    if (Object.keys(this.localSearchData).length > 0) {
      setSessionItem("pageNo", this.tableName, {
        pageNo: this.pageNoCode,
        searchForm: this.localSearchData
      });
    }
    let localData = getSessionItem("pageNo", this.tableList.listqueryList);
    let data = localData && localData.searchForm;
    this.getUserList({ ...this.formDataSearch, ...data });
  }
};
</script>
